import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';

import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import FormToggleBool from '../../common/FormToggleBool';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation, Trans } from 'react-i18next';
import { useAppDispatch } from '../../../hooks';
import { archiveGame } from '../../../reducers/gameReducer';

export interface ArchiveProps {
  done: () => void;
  id: string | undefined;
  cancel: () => void;
}

function Archive({ done, id, cancel }: ArchiveProps) {
  const { handleSubmit, control } = useForm();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const handleArchive = (data: any) => {
    if (!id) return;
    dispatch(archiveGame({ id, lockSignOff: data.lockSignOff }))
      .unwrap()
      .then(() => {
        toast.success(t('Game successfully archived'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to archive game'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Archive confirmation')}
      cancel={cancel}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <p>
          {t(
            'Once the game is archived, users will not be able to request keys.'
          )}
        </p>
        <p>
          <Trans i18nKey="archiveConfirmation" components={{ bold: <b /> }}>
            You can also <strong>'Lock sign-off'</strong> meaning outstanding
            requests will be locked and no further keys will be assigned.
          </Trans>
        </p>
        <FormToggleBool
          control={control}
          name="lockSignOff"
          label={t('Lock sign-off?')}
          defaultValue={false}
        />
        <hr />
        <Button
          testId='confirm-archive-game'
          className="btn btn-danger me-2"
          onClick={handleSubmit(handleArchive)}
          text={t("Yes, archive the game and it's skus")}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default Archive;
